module.exports = [{"id":"en","name":"English"},{"id":"es","name":"Español"},{"id":"ko","name":"Kreyòl ayisyen"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/languages.json
// module id = 338
// module chunks = 0